import {EventEmitter, Injectable}   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class TipoPatrimonioService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Tipo de Patrimonios por id
     * @param id ID da Tipo de Patrimonios
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "tipo-patrimonios/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Tipo de Patrimonios
     * @param id ID da Tipo de Patrimonios
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "tipo-patrimonios"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Tipo de Patrimonios
     * @param id ID da Tipo de Patrimonios
     */
    search(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "tipo-patrimonios"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Tipo de Patrimonios
     * @param id ID da Tipo de Patrimonios
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "tipo-patrimonios/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Tipo de Patrimonios
     * @param params Json Tipo de Patrimonios
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "tipo-patrimonios", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Tipo de Patrimonios
     * @param params Json Tipo de Patrimonios
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "tipo-patrimonios/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
